"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getRoutes = exports.appRoutes = void 0;
const react_1 = __importDefault(require("react")); //eslint-disable-line no-unused-vars
const react_router_1 = require("react-router");
const react_router_2 = require("react-router");
const common_1 = require("@epic-core/common");
function appRoutes(routeDefinition) {
    const path = common_1.getPath();
    const routes = routeDefinition.map(entry => {
        return Object.assign(Object.assign({}, entry), { key: entry.path, path: `${path}:locale/${entry.path}` });
    });
    return routes;
}
exports.appRoutes = appRoutes;
function getRoutes(routeDefinition, location) {
    const routes = appRoutes(routeDefinition);
    const locationObj = typeof location.toJS === 'function' ? location.toJS() : location;
    const routeSwitch = (react_1.default.createElement(react_router_2.Switch, { location: locationObj }, routes.map(pluginComponent => {
        return react_1.default.createElement(react_router_1.Route, Object.assign({ key: pluginComponent.key }, pluginComponent));
    })));
    return routeSwitch;
}
exports.getRoutes = getRoutes;
//# sourceMappingURL=RouteUtils.js.map